import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '../../components/buttons'

export const AccountCreated = ({ location }) => {
  const history = useHistory()

  if (!location.state) {
    return null
  }

  const handleNowClick = () => {
    history.replace({ pathname: '/new' })
  }

  const handleLaterClick = () => {
    history.replace({ pathname: '/' })
  }

  return (
    <div className="container-md py-64">
      <div className="bg-white border-1 border-gray-200 shadow-100 rounded-10 px-20 sm:px-32 py-32 text-center">
        <p className="text-30 text-purple-dark font-bold mb-20">
          Thanks! Your account has been created.{' '}
        </p>
        <p className="mb-48">
          Now you can add the people in your social circle to compare habits.
        </p>
        <div className="flex flex-col items-center sm:flex-row sm:justify-center">
          <Button
            onClick={handleNowClick}
            className="bg-purple-light border-2 border-purple-light text-white rounded-10 mb-12 sm:mb-0 sm:mr-12"
          >
            Add People Now
          </Button>
          <Button
            onClick={handleLaterClick}
            className="border-2 border-purple-dark text-purple-dark rounded-10"
          >
            Add People Later
          </Button>
        </div>
      </div>
    </div>
  )
}
